
import store from '@/store';
import { defineComponent } from 'vue';
import { GlobalPagination } from '@/interfaces/panel/global-pagination.model';
import IpgTransactionSkelton from '@/components/transactionsComponents/IpgTransactionSkelton.vue';
import WithdrawalsTableComponent from '@/components/transactionsComponents/WithdrawalsTable.vue';
import CustomPaginationComponent from '@/components/appComponents/CustomPagination.vue';

export default defineComponent({
    name: "WithdrawalsListPage",

    components: { IpgTransactionSkelton, WithdrawalsTableComponent, CustomPaginationComponent },
    emits: ['back'],

    data() {
        return {
            user: ""
        }
    },

    computed: {
        getLoadingPanel(): boolean {
            return store.getters["panel/getLoadingPanel"];
        },

        getAllWithdrawals() {
            return store.getters["panel/getAllWithdrawals"];
        },

        getGlobalPagination(): GlobalPagination {
            return store.getters["panel/getGlobalPagination"];
        }
    },

    methods: {
        handelPagination() {
            store.dispatch("panel/getAllWithdrawalsRequest");
        },

    },

    mounted() {
        store.dispatch("panel/getAllWithdrawalsRequest");
    }
})
